import styled from 'styled-components';
import { IconButton } from 'src/components/general/button/icon-button';
import { FlexColumn } from 'src/components/layout/flex-column';
import { FlexRow } from 'src/components/layout/flex-row';

export const Thumb = styled.img`
  background-color: ${({ theme }) => theme.colors.porcelain};
  border-radius: 6px;
  flex-shrink: 0;
  height: 70px;
  object-fit: cover;
  width: 70px;
`;

export const ThumbInfoWrapper = styled(FlexRow)`
  align-items: center;
  flex: 1;
  gap: 15px;
  min-width: 0;
`;

export const VehicleInfo = styled(FlexColumn)`
  flex: 1;
  gap: 1px;
  min-width: 0;
`;

export const VehicleTitle = styled.span`
  color: ${({ theme }) => theme.colors.smalt};
  font-family: ${({ theme }) => theme.font.medium};
  font-size: 13px;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const VehiclePrice = styled.span`
  color: ${({ theme }) => theme.colors.smalt};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 13px;
  line-height: 15px;
`;

export const VehicleMeta = styled.span`
  color: ${({ theme }) => theme.colors.flint};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 12px;
  line-height: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ToggleCircle = styled(IconButton)<{ $selected: boolean }>`
  cursor: pointer;
  flex-shrink: 0;

  .lgg-icon svg {
    height: 20px;
    width: 20px;
  }

  .lgg-icon svg path {
    fill: ${({ theme, $selected }) =>
      $selected ? theme.colors.secondaryCoral80 : theme.colors.smalt};
  }

  &:hover:not(:disabled) .lgg-icon svg path {
    fill: ${({ theme, $selected }) =>
      $selected ? theme.colors.secondaryCoral80 : theme.colors.gogo};
  }

  &:disabled {
    cursor: not-allowed;

    .lgg-icon svg path {
      fill: ${({ theme }) => theme.colors.casper};
    }
  }
`;

export const DrawerBody = styled(FlexColumn)`
  height: 100%;
`;

export const StickyFooter = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-top: 1px solid ${({ theme }) => theme.colors.koala};
  padding: 15px 20px;
`;

export const FooterRow = styled(FlexRow)`
  gap: 20px;

  & > * {
    flex: 1;
  }
`;

export const StatusMessage = styled(FlexColumn)`
  align-items: center;
  color: ${({ theme }) => theme.colors.flint};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 13px;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
`;

export const ScrollableSection = styled.div`
  background: ${({ theme }) => theme.colors.white};
  flex: 1;
  min-height: 0;
`;
